exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#cookie-warning{width:60%;margin-left:20%;background-color:rgba(21,202,191,.1)}#cookie-warning .cookie-text{padding:10px;color:#263238}#cookie-warning .cookie-text .allow{color:#fafafa;background-color:#18e171}#cookie-warning .cookie-text .forbid{background-color:#e11824;color:#fafafa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aafb8092","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cookieWarning.vue
// module id = 53
// module chunks = 0